export default "__VITE_ASSET__C6qYqoo9__"